import React from 'react';

const RefundPolicy = () => {
    return (
        <div className="min-h-screen bg-slate-50 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto bg-white shadow-sm rounded-2xl overflow-hidden border border-slate-200">
                <div className="bg-slate-900 px-8 py-10 text-white">
                    <h1 className="text-3xl font-bold mb-2">Refund & Cancellation Policy</h1>
                    <p className="text-slate-400">Effective Date: February 23, 2026</p>
                </div>

                <div className="p-8 md:p-12 space-y-8 text-slate-700 leading-relaxed">
                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">1. Cancellation Policy</h2>
                        <p>
                            At Paper Portal, we understand that plans can change. However, due to the nature of our digital services and the resources allocated to each project, we have a specific cancellation window.
                        </p>
                        <ul className="list-disc ml-6 mt-4 space-y-2">
                            <li><strong>Cancellation Window:</strong> Users are allowed to cancel a service request only within <strong>24 hours</strong> of the selection or assignment of a reviewer for their submission.</li>
                            <li><strong>Method:</strong> Cancellation requests must be sent via your registered email to <a href="mailto:helpdesk@paperportal.in" className="text-indigo-600 hover:underline">helpdesk@paperportal.in</a> with the subject line "Cancellation Request - [Your Submission ID]".</li>
                            <li><strong>Post-Window:</strong> No cancellation requests will be entertained after the 24-hour window has elapsed.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">2. Refund Conditions</h2>
                        <p>
                            Refunds are subject to a thorough verification process by our team.
                        </p>
                        <ul className="list-disc ml-6 mt-4 space-y-2">
                            <li><strong>Membership Charges:</strong> Please note that all charges related to memberships, subscriptions, or platform access fees are <strong>non-refundable</strong> under any circumstances.</li>
                            <li><strong>Generic Refunds:</strong> Refunds for service fees (other than membership) are only considered if the service has not been initiated or if there is a documented failure on our part to deliver the specified service.</li>
                            <li><strong>Verification:</strong> Every refund request is subject to the verification of a genuine reason. Paper Portal reserves the right to approve or reject a refund request based on its internal evaluation.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-slate-900 mb-4 pb-2 border-b border-slate-100">3. Refund Processing</h2>
                        <p>
                            Once a refund request is approved:
                        </p>
                        <ul className="list-disc ml-6 mt-4 space-y-2">
                            <li><strong>Timeline:</strong> The refund will be processed within <strong>7 to 10 working days</strong> from the date of approval.</li>
                            <li><strong>Method:</strong> The amount will be credited back to the original payment source (Credit Card, Debit Card, Net Banking, or UPI) used at the time of purchase.</li>
                            <li><strong>Bank Delays:</strong> While we initiate the refund within the specified timeline, actual credit to your account may depend on your bank's internal processing times.</li>
                        </ul>
                    </section>

                    <section className="bg-slate-50 p-6 rounded-xl border border-slate-200">
                        <h2 className="text-xl font-bold text-slate-900 mb-4">4. Contact for Policy Queries</h2>
                        <p className="mb-4">If you have any questions regarding our Refund and Cancellation Policy, please contact our support desk:</p>
                        <div className="space-y-2 text-sm md:text-base">
                            <p><strong>Support Email:</strong> helpdesk@paperportal.in</p>
                            <p><strong>Support Phone:</strong> +91 7890 10 4000</p>
                            <p><strong>Working Hours:</strong> Monday - Friday (9:00 - 18:00)</p>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default RefundPolicy;
